import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">平台优势</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            为什么500万观众选择木瓜影视在线观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-5xl mx-auto">
          {featureItems.map((item, index) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both` }}
            >
              <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className={`${item.icon} text-primary-600 text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}